import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";

const UserCarsFormModal = ({
  isOpen,
  onClose,
  onSave,
  item,
  mode,
  language,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (item) {
      setFormData({
        name: item.name || "",
        description: item.description || "",
      });
    } else {
      setFormData({
        name: "",
        description: "",
      });
    }
    setErrors({});
  }, [item, isOpen]);

  const labels = {
    addTitle: { en: "Add Car", ar: "إضافة سيارة" },
    editTitle: { en: "Edit Car", ar: "تعديل السيارة" },
    name: { en: "Car Name", ar: "اسم السيارة" },
    description: { en: "Description", ar: "الوصف" },
    cancel: { en: "Cancel", ar: "إلغاء" },
    save: { en: "Save", ar: "حفظ" },
    required: { en: "This field is required", ar: "هذا الحقل مطلوب" },
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.name?.trim()) {
      newErrors.name = labels.required[language];
    }

    if (!formData?.description?.trim()) {
      newErrors.description = labels.required[language];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSave(formData);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-xl">
        
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">
            {mode === "add"
              ? labels.addTitle[language]
              : labels.editTitle[language]}
          </h2>

          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">

          {/* Name */}
          <Input
            type="text"
            label={labels.name[language]}
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            error={errors.name}
            required
          />

          {/* Description */}
          <Input
            type="text"
            label={labels.description[language]}
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            error={errors.description}
            required
          />

          {/* Buttons */}
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" fullWidth onClick={onClose}>
              {labels.cancel[language]}
            </Button>

            <Button type="submit" variant="default" fullWidth>
              {labels.save[language]}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserCarsFormModal;
